import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { Fragment } from '../fragment'
import { FragmentProps } from '../types/fragment-types'

export const mount: MountWithRootOptions<FragmentProps> = async (
  rootElement,
  renderProps,
  rootOptions
) => {
  return clientMount(<Fragment {...renderProps} />, rootElement, rootOptions)
}
